webpackJsonp([15],{

/***/ 1025:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_main_report_js__ = __webpack_require__(1133);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24527998_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_report_vue__ = __webpack_require__(1322);
var normalizeComponent = __webpack_require__(494)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_main_report_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24527998_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1052:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  PrintsendShiftHost: function PrintsendShiftHost(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/send/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleDetail: function saleDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  salePosDetail: function salePosDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/pos/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleCreditDetail: function saleCreditDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/credit/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleHoldDetail: function saleHoldDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/holdbill/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleSummary: function saleSummary(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/total/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  expenseReport: function expenseReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/report/expense', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  profitReport: function profitReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'stock/v1/report/profit/item/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  movementReport: function movementReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'stock/v1/report/tran/itemtoitem', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  stockReport: function stockReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'stock/v1/report/stock/remain', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_report_sendShiftHost__ = __webpack_require__(1320);


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SendShiftHost: __WEBPACK_IMPORTED_MODULE_0__components_report_sendShiftHost__["a" /* default */]
  },
  data: function data() {
    return {
      bt_type: 0
    };
  },

  methods: {
    goToPage: function goToPage(path) {
      this.$store.state.historyPage = this.$route.path;
      this.$router.push(path);
    },
    doing: function doing() {
      alert('รอดำเนินการ');
    },
    Modal: function Modal(type) {
      this.bt_type = type;
      $('#ModalReport').modal('show');
    }
  },
  mounted: function mounted() {
    this.$store.state.historyPage = '';
    this.checkUser();
  }
});

/***/ }),

/***/ 1134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service_report__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_pos__ = __webpack_require__(498);




var moment = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      host_list: [],
      host: '',
      datenow: moment(new Date(), 'YYYY/MM/DD'),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }
    };
  },

  methods: {
    onChange: function onChange(date) {
      this.datenow = moment(date, 'YYYY/MM/DD');
    },
    getListHost: function getListHost() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__services_service_pos__["a" /* default */].getHostShift(this.REST_URL, this.header, function (result) {
        if (result.response === 'success') {
          _this.host_list = result.data;
          _this.host = _this.host_list[0];
        } else {
          _this.$notification['warning']({
            message: 'ดึงข้อมูลจุดขายไม่ได้',
            description: result.message
          });
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    printSendShift: function printSendShift() {
      var _this2 = this;

      var obj = {
        host_code: this.host.host_code,
        doc_date: this.dateFormatDMY2(this.datenow),
        printer_port: this.host.printer_port
      };
      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_1__services_service_report__["a" /* default */].PrintsendShiftHost(this.REST_URL, this.header, obj, function (result) {
        if (result.response === 'success') {
          _this2.alert_msg('success', 'พิมพ์ใบนำส่งเงิน', 'พิมพ์ใบนำส่งเงินประจำ ' + _this2.host.host_name + ' เรียบร้อย');
          $('#ModalReport').modal('hide');
          $('body').on('hidden.bs.modal', '.modal', function () {
            console.clear();
            $(this).removeData('bs.modal');
          });
        } else {
          _this2.alert_msg('warning', 'พิมพ์ใบนำส่งเงิน', result.message);
          $('#ModalReport').modal('hide');
          $('body').on('hidden.bs.modal', '.modal', function () {
            console.clear();
            $(this).removeData('bs.modal');
          });
        }
        _this2.$store.commit('Loading');
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this2.$store.commit('Loading');
        $('#ModalReport').modal('hide');
        $('body').on('hidden.bs.modal', '.modal', function () {
          console.clear();
          $(this).removeData('bs.modal');
        });
      });
    }
  },
  mounted: function mounted() {
    $('#ModalReport').on('show.bs.modal', function () {
      this.getListHost();
    }.bind(this));
  }
});

/***/ }),

/***/ 1320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_report_sendShiftHost_js__ = __webpack_require__(1134);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aed72974_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendShiftHost_vue__ = __webpack_require__(1321);
var normalizeComponent = __webpack_require__(494)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_report_sendShiftHost_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aed72974_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendShiftHost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body p-2",staticStyle:{"font-size":"18px"}},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label pl-5",attrs:{"for":"Host"}},[_vm._v("จุดขาย")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.host),expression:"host"}],staticClass:"custom-select mr-sm-2",attrs:{"id":"Host"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.host=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.host_list),function(h,i){return _c('option',{key:'host' + i,domProps:{"value":h}},[_vm._v(_vm._s(h.host_name))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label pl-5",attrs:{"for":"Host"}},[_vm._v("วันที่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('a-date-picker',{attrs:{"format":'DD/MM/YYYY'},on:{"change":_vm.onChange},model:{value:(_vm.datenow),callback:function ($$v) {_vm.datenow=$$v},expression:"datenow"}})],1)]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-lg",staticStyle:{"width":"100%"},attrs:{"role":"group"}},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n        ยกเลิก\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.printSendShift}},[_vm._v("\n        พิมพ์\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"ModalReportTitle"}},[_vm._v("พิมพ์ใบนำส่งเงิน")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mt-3",style:({ 'min-height' : _vm.$store.state.screenHeight - 100 + 'px' })},[_c('div',{staticClass:"card-body text-center"},[_c('h1',{staticStyle:{"font-weight":"bold"}},[_vm._v("รายงานทั้งหมด")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center align-items-start flex-wrap"},[_c('div',{staticClass:"menu-box d-flex flex-column justify-content-center align-items-center",on:{"click":function($event){return _vm.Modal(0)}}},[_c('i',{staticClass:"fas fa-receipt",staticStyle:{"font-size":"90px"}}),_vm._v(" "),_c('h5',{staticClass:"mt-3"},[_vm._v("พิมพ์ใบนำส่งเงิน")])]),_vm._v(" "),_c('div',{staticClass:"menu-box d-flex flex-column justify-content-center align-items-center",on:{"click":function($event){return _vm.goToPage('/report_sale')}}},[_c('i',{staticClass:"fas fa-money-bill-wave",staticStyle:{"font-size":"90px"}}),_vm._v(" "),_c('h5',{staticClass:"mt-3"},[_vm._v("รายงานยอดขายประจำวัน")])]),_vm._v(" "),_c('div',{staticClass:"menu-box d-flex flex-column justify-content-center align-items-center",on:{"click":function($event){return _vm.goToPage('/report_saleitem')}}},[_c('i',{staticClass:"fas fa-file-signature",staticStyle:{"font-size":"90px"}}),_vm._v(" "),_c('h5',{staticClass:"mt-1"},[_vm._v("รายงานยอดขายตามสินค้า")])]),_vm._v(" "),_c('div',{staticClass:"menu-box d-flex flex-column justify-content-center align-items-center",on:{"click":function($event){return _vm.goToPage('/reportexpend')}}},[_c('i',{staticClass:"fas fa-scroll",staticStyle:{"font-size":"90px"}}),_vm._v(" "),_c('h5',{staticClass:"mt-3"},[_vm._v("รายงานค่าใช้จ่าย")])]),_vm._v(" "),_c('div',{staticClass:"menu-box d-flex flex-column justify-content-center align-items-center",on:{"click":function($event){return _vm.goToPage('/reportstock')}}},[_c('i',{staticClass:"fas fa-clipboard-list",staticStyle:{"font-size":"90px"}}),_vm._v(" "),_c('h5',{staticClass:"mt-1"},[_vm._v("รายงานสต๊อกสินค้า")])]),_vm._v(" "),_c('div',{staticClass:"menu-box d-flex flex-column justify-content-center align-items-center",on:{"click":function($event){return _vm.goToPage('/reportstockegg')}}},[_c('i',{staticClass:"fas fa-clipboard-list",staticStyle:{"font-size":"90px"}}),_vm._v(" "),_c('h5',{staticClass:"mt-1"},[_vm._v("รายงานสต๊อกสินค้าไข่")])]),_vm._v(" "),(_vm.$store.state.user.role_id < 4)?_c('div',{staticClass:"menu-box d-flex flex-column justify-content-center align-items-center",on:{"click":function($event){return _vm.goToPage('/reportcostsale')}}},[_c('i',{staticClass:"fas fa-tasks",staticStyle:{"font-size":"90px"}}),_vm._v(" "),_c('h5',{staticClass:"mt-1"},[_vm._v("รายงานกำไรขั้นต้น")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"menu-box d-flex flex-column justify-content-center align-items-center",on:{"click":function($event){return _vm.goToPage('/reportproductmovement')}}},[_c('i',{staticClass:"fas fa-file-invoice-dollar",staticStyle:{"font-size":"90px"}}),_vm._v(" "),_c('h5',{staticClass:"mt-1"},[_vm._v("รายงานเคลื่อนไหวสินค้า")])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"ModalReport","tabindex":"-1","role":"dialog","aria-labelledby":"ModalReportCenterTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[(_vm.bt_type === 0)?_c('SendShiftHost'):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/15.fefe3fa89c892377226b.js